export default __webpack_public_path__ + "static/media/coin_5gm.934081eb.jpg";